<template>
    <div ref="confirmModalRef" class="modal fade" id="confirmModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="confirmModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-centered mx-auto" role="document">
            <div class="modal-content border-0 shadow">
                <div class="modal-body p-4 text-center">
                    <span class="fw-medium" id="confirmModalLabel">{{ title }}</span>
                </div>
                <div class="modal-footer flex-nowrap p-0">
                    <button type="button" class="btn btn-lg btn-link fs-6 text-decoration-none col-6 py-3 m-0 rounded-0 border-end" data-bs-dismiss="modal" @click="cancel">取消</button>
                    <button type="button" class="btn btn-lg btn-link link-danger fs-6 text-decoration-none col-6 py-3 m-0 rounded-0" data-bs-dismiss="modal" @click="confirm">確認</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';
import { Modal } from 'bootstrap';

export default {
    name: 'ConfirmModal',
    props: {
        title: {
            type: String,
            default: '確定要執行此操作嗎？'
        }
    },
    setup(props, { emit }) {
        const confirmModalRef = ref(null);
        let confirmModalInstance = null;

        onMounted(() => {
            // Instantiate the modal with the ref
            if (confirmModalRef.value) {
                confirmModalInstance = new Modal(confirmModalRef.value);
            } else {
                console.log("Modal instance can't be initialized.");
            }
        });

        onUnmounted(() => {
            // Cleanup the modal instance if necessary
            if (confirmModalInstance) {
                confirmModalInstance?.dispose();
            }
        });

        const openModal = () => {
            confirmModalInstance.show();
            // fix modal backdrop z-index
            let backdrops = document.querySelectorAll('.modal-backdrop');
            if (backdrops.length > 1) {
              backdrops[1].style.zIndex = 1056;
            }
        };

        const closeModal = () => {
            confirmModalInstance.hide();
            // 尋找 z-index 為 1056 的 modal backdrop
            let backdrops = document.querySelectorAll('.modal-backdrop');
            for (let i = 0; i < backdrops.length; i++) {
              if (backdrops[i].style.zIndex === '1056') {
                backdrops[i].style.zIndex = '1050';
                break; // 找到符合條件的就跳出迴圈
              }
            }
        };

        const cancel = () => {
            closeModal();
        };

        const confirm = () => {
            emit('confirm');
            closeModal();
        };

        return {
            confirmModalRef,
            openModal,
            closeModal,
            cancel,
            confirm
        };
    }
}

</script>

<style lang="scss" scoped>
  #confirmModal {
    z-index: 1057;
  }
</style>
